import request from '@/utils/request'

// 生产环境
let BASE_URL = 'https://api.tgjiaoben.xyz'
// 测试环境
// let BASE_URL = 'http://127.0.0.1:7003'

export function getGoodsList (classified) {
  return request({
    url: BASE_URL + '/pc/api/v1/mall/select-options/goods-skus',
    method: 'get',
    params: {
      classified
    }
  })
}
export function searchOrderApi (data) {
  return request({
    url: BASE_URL + '/pc/api/v1/mall/order-query',
    method: 'post',
    data: data
  })
}
export function downApi (params) {
  return request({
    url: BASE_URL + '/pc/api/v1/mall/extract',
    method: 'get',
    params: params,
    timeout: 600000
  })
}
export function buyApi (data) {
  return request({
    url: BASE_URL + '/pc/api/v1/mall/buy',
    method: 'post',
    data: data
  })
}
export const duplicateCheckFileUploadApiUrl = BASE_URL + '/pc/api/v1/mall/duplicate-check'

export function getAnnouncementText () {
  return request({
    url: BASE_URL + '/pc/api/v1/mall/announcement-text',
    method: 'get',
    params: {}
  })
}



// WEBPACK FOOTER //
// ./src/api/http.js